import { WarningCircleIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import * as S from './parking-session-error.styled'

export const ParkingSessionError = () => {
  const { t } = useTranslation(['visitor-parking'])

  return (
    <S.Card>
      <S.ErrorIcon icon={WarningCircleIcon} size="8rem" />
      <S.ErrorInfo>{t('visitor-parking:parkingSessionError.title')}</S.ErrorInfo>
      <S.ErrorDescription>
        {t('visitor-parking:parkingSessionError.description')}
      </S.ErrorDescription>
    </S.Card>
  )
}
